<template>
    <CompassTooltip
        :content="getTooltipContent"
        placement="bottom-start"
        :arrow="false"
        :disabled="!getTooltipContent"
    >
        <div class="automation-pieces">
            <div
                v-for="(piece, index) in visiblePieces"
                :key="index"
                class="automation-pieces__bubble"
            >
                <img v-if="piece.logoUrl" :src="piece.logoUrl" :alt="piece.displayName" />
            </div>
            <div v-if="remainingCount" class="typographies-heading-h4 automation-pieces__bubble">
                +{{ remainingCount }}
            </div>
        </div>
    </CompassTooltip>
</template>

<script>
const NUMBER_OF_PIECES_TO_SHOW = 3;
export default {
    name: 'AutomationPieces',
    props: {
        pieces: {
            type: Array,
            required: true,
        },
    },
    computed: {
        validPieces() {
            return this.pieces.filter((piece) => piece && piece.logoUrl && piece.displayName);
        },
        visiblePieces() {
            return this.validPieces.length > NUMBER_OF_PIECES_TO_SHOW
                ? this.validPieces.slice(0, NUMBER_OF_PIECES_TO_SHOW - 1)
                : this.validPieces;
        },
        remainingCount() {
            return this.validPieces.length > NUMBER_OF_PIECES_TO_SHOW
                ? this.validPieces.length - (NUMBER_OF_PIECES_TO_SHOW - 1)
                : null;
        },
        getTooltipContent() {
            return this.validPieces
                .map((piece) => {
                    return piece.displayName
                        .split(' ')
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                        .join(' ');
                })
                .join(', ');
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-pieces {
    display: flex;
    align-items: center;
    gap: 2px;

    &__bubble {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        border: 1px solid var(--colors-common-border-lighter);
        overflow: hidden;

        img {
            width: 18px;
            height: 18px;
            object-fit: contain;
        }
    }
}
</style>
